
import { Component, Prop, Vue } from 'vue-property-decorator';
import lambdaRequest from '@/helpers/lambdaRequest';
import { NOTIFICATION } from '@/entities/Events';
import Message from '@/data/notificationsMessages';
import ResendInvitationNew from '@/components/invite/ResendInvitationNew.vue';
import ResendInvitationConfirmation from '@/components/common/ResendInvitationConfirmation.vue';

@Component({
	components: {
		ResendInvitationNew,
		ResendInvitationConfirmation,
	},
})
export default class ManagerResendInvitation extends Vue {
	@Prop({ type: String, required: true }) readonly managerId!: string;
	@Prop({ type: String, required: true }) readonly adminUserId!: string;
	@Prop({ type: String, required: true }) readonly givenName!: string;
	@Prop({ type: String, required: true }) readonly familyName!: string;

	processing: boolean = false;
	invitationResent: boolean = false;

	async resendInvitation(): Promise<void> {
		if (this.invitationResent || this.processing) {
			return;
		}

		this.processing = true;

		try {
			await lambdaRequest({
				lambdaName: 'resendManagerInvitation',
				requestData: {
					manager_id: this.managerId,
					admin_user_id: this.adminUserId,
				},
			});

			this.invitationResent = true;
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage('Invite sent')
			);
			this.$emit('invitationResent');
		} catch (error) {
			this.$eventBus.emit(
				NOTIFICATION,
				Message.errorMessage('Something went wrong!')
			);
		} finally {
			this.processing = false;
		}
	}
}
